import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    "PVID": 1,
    "allowVlan": "1-3,11,111,1111",
    "assignedPort": [],
    "ddpState": true,
    "deviceCategory": "ap",
    "id": "0352682d-cda9-4927-80e0-946c536aaaaa",
    "lbdState": true,
    "name": "AP-Profile-A",
    "poeState": true,
    "portState": true,
    "portTags": [],
    "portType": "access",
    "sfpSpeed": "auto",
    "speed": "auto",
    "version": 10,
    "accessPolicy": {
      "enableState": false,
      "type": "STATIC",
      "macList": null,
      "radiusProfile": null,
      "dynamicSize": null,
    }
  },
  {
    "PVID": 2,
    "allowVlan": "2-4,22,222,2222",
    "assignedPort": [],
    "ddpState": true,
    "deviceCategory": "ap",
    "id": "0352682d-cda9-4927-80e0-946c536bbbbb",
    "lbdState": true,
    "name": "AP-Profile-B",
    "poeState": true,
    "portState": true,
    "portTags": [],
    "portType": "access",
    "sfpSpeed": "auto",
    "speed": "auto",
    "version": 10,
    "accessPolicy": {
      "enableState": false,
      "type": "STATIC",
      "macList": null,
      "radiusProfile": null,
      "dynamicSize": null,
    }
  },
  {
    "PVID": 1,
    "allowVlan": "1-3,11,111",
    "assignedPort": ["DBS-2000-28:1", "DBS-2000-28:2"],
    "ddpState": true,
    "deviceCategory": "switch",
    "id": "0352682d-cda9-4927-80e0-946c536ccccc",
    "lbdState": true,
    "name": "SW-Profile-A",
    "poeState": true,
    "portState": true,
    "portTags": [],
    "portType": "access",
    "sfpSpeed": "auto",
    "speed": "auto",
    "version": 10,
    "portSchedule": null,
    "poeSchedule": null,
    "accessPolicy": {
      "enableState": false,
      "type": "STATIC",
      "macList": null,
      "radiusProfile": null,
      "dynamicSize": null,
    }
  },
  {
    "PVID": 2,
    "allowVlan": "2-4,22,222",
    "assignedPort": [],
    "ddpState": true,
    "deviceCategory": "switch",
    "id": "0352682d-cda9-4927-80e0-946c536ddddd",
    "lbdState": true,
    "name": "SW-Profile-B",
    "poeState": true,
    "portState": true,
    "portTags": [],
    "portType": "trunk",
    "sfpSpeed": "auto",
    "speed": "auto",
    "version": 10,
    "portSchedule": null,
    "poeSchedule": null,
    "accessPolicy": {
      "enableState": false,
      "type": "STATIC",
      "macList": null,
      "radiusProfile": null,
      "dynamicSize": null,
    }
  },
];

const initialState = {
  data: [...fakeData],
};

export const profilesSlices = createSlice({
  name: "profilesPort",
  initialState,
  reducers: {
    setProfilesPortsData: (state) => {
      state.data = [...fakeData];
    },
    createProfilesPort: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const newProfile = {
        ...payload,
        id: `profile-port-${(fakeData.length + 1).toString().padStart(3, "0")}`,
        assignedPort: [],
        version: 1,
      };

      fakeData = [...fakeData, newProfile];
      state.data.push(newProfile);
    },
    updateProfilesPort: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const index = state.data.findIndex((item) => item.id === payload.id);

      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...payload,
          assignedPort: fakeData[index].assignedPort ?? [],
          version: (fakeData[index].version ?? 0) + 1,
        };
        state.data[index] = {
          ...state.data[index],
          ...fakeData[index],
        };
      }
    },
    deleteProfilesPort: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const deleteId = payload.portId ?? payload.id;

      state.data = state.data.filter((item) => item.id !== deleteId);
      fakeData = fakeData.filter((item) => item.id !== deleteId);
    },
  },
});

export const {
  setProfilesPortsData,
  createProfilesPort,
  updateProfilesPort,
  deleteProfilesPort,
} = profilesSlices.actions;

export default profilesSlices.reducer;
